module.exports = __webpack_public_path__ + "static/djez_3-aec0d3b328c4173d47f631fda11d40d2.jpg";